export const hnActivatedSettingsBannerConfig = {
  title: 'Hypernative Guardian',
  description:
    'Automatically monitor and block risky transactions using advanced, user-defined security policies powered by Hypernative.',
  statusLabel: 'Active',
  buttonLabel: 'View on Hypernative',
  // Dummy URL for now
  dashboardUrl: 'https://app.hypernative.xyz/guardian',
} as const
